import { DebouncedFunc } from 'lodash-es';
import throttle from 'lodash-es/throttle';
import * as React from 'react';

import Arrow from './Arrow';

interface Props {
    sendChatMessage: (message: string) => void;
    sendIsTyping: (isTyping: boolean) => void;
}

interface State {
    value: string;
}

class Input extends React.Component<Props, State> {
    throtteledSendIsTyping: DebouncedFunc<((isTyping: boolean) => void)>;
    constructor(props: Props) {
        super(props);
        this.state = {
            value: '',
        };
        this.throtteledSendIsTyping = throttle(props.sendIsTyping, 300);
    }
    handleChange = (event: React.FormEvent<HTMLTextAreaElement>) => {
        const value = event.currentTarget.value;
        this.throtteledSendIsTyping(!!value);
        this.setState({ value });
    }
    handleSend = () => {
        const { value } = this.state;
        if (!value) {
            return;
        }
        this.throtteledSendIsTyping.cancel();
        this.props.sendChatMessage(value);
        this.setState({ value: '' });
        this.props.sendIsTyping(false);
    }
    handleKeyPress = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.keyCode === 13 && event.shiftKey === false) {
            event.preventDefault();
            this.handleSend();
        }
    }
    render() {
        const { value } = this.state;
        return <div className='chat-input'>
            <textarea value={value} onChange={this.handleChange} onKeyDown={this.handleKeyPress} />
            <button onClick={this.handleSend}>
                <Arrow />
            </button>
        </div>;
    }
    componentWillUnmount() {
        this.throtteledSendIsTyping.cancel();
    }
}

export default Input;
